<template>
  <section class="section-hero-jobs-list py-5 py-lg-6">
    <div class="container text-purple">
      <div class="row">
        <div class="col-12">
          <h1 class="display-3 fw-bold pt-5">
            Möglichkeiten<br class="d-md-none" />
            entdecken
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <h2 class="fw-medium fs-2 mb-5">Unsere Stellenangebote für Sie</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-6">
          <div
            :class="[workers > 0 ? ' icon-searching' : ' icon-search']"
            class="wrapper-icon"
          >
            <delayed-search
              v-model="search"
              aria-describedby="basic-addon1"
              aria-label="Suche"
              class="form-control mb-4"
              placeholder="Suche"
            />
          </div>
        </div>
        <div v-if="templateOptions.city_filter" class="col-12 col-lg-6">
          <div class="wrapper-icon icon-location">
            <div class="input-group">
              <location-search
                v-model="location"
                :search-api="apiEndpoints.cities"
                placeholder="Ort"
              ></location-search>
              <distance-dropdown
                v-model="radius"
                :distances="[10, 20, 30, 40, 50, 75, 100]"
                aria-expanded="false"
                class="btn btn-primary rounded-0 rounded-end text-white z-1"
                zero-default="genauer Standort"
              ></distance-dropdown>
            </div>
          </div>
        </div>
      </div>
      <div class="row filter d-none d-lg-flex">
        <div v-if="templateOptions.business_filter" class="col-3">
          <filter-select
            v-model="businessFilters"
            :labels="filters.business"
            placeholder="Bereich"
          ></filter-select>
          <filter-container
            v-model="businessFilters"
            :labels="filters.business"
          ></filter-container>
        </div>
        <div v-if="templateOptions.type_filter" class="col-3">
          <filter-select
            v-model="typesFilters"
            :labels="filters.types"
            placeholder="Anstellungsart"
          ></filter-select>
          <filter-container
            v-model="typesFilters"
            :labels="filters.types"
          ></filter-container>
        </div>
        <div v-if="templateOptions.contract_filter" class="col-3">
          <filter-select
            v-model="contractsFilters"
            :labels="filters.contracts"
            placeholder="Vertragsart"
          ></filter-select>
          <filter-container
            v-model="contractsFilters"
            :labels="filters.contracts"
          ></filter-container>
        </div>
        <div class="col-3 text-center">
          <button class="btn btn-primary w-100 text-white" @click="resetFilters">
            Alle Filter löschen
          </button>
        </div>
      </div>
    </div>
  </section>
  <section class="section-jobs-list bg-white py-5 mb-6 mb-lg-0">
    <div class="container">
      <div class="row pt-lg-3">
        <template v-if="hasSearchResults">
          <div v-for="job in jobs" class="col-12">
            <div class="py-4 border-top position-relative">
              <a :href="'/stellenangebot/' + job.slug" class="stretched-link"></a>
              <h2 class="h4 text-primary fw-semibold">{{ job.title }}</h2>
              <span class="d-inline-block me-3"
                ><i class="fas fa-fw fa-map-marker"></i>
                <template v-if="job.initiativ === true"> Ganz in der Nähe </template>
                <template v-else>
                  <template v-if="job.workplaces">
                    {{ job.workplaces[0].city }}
                    <template v-if="job.workplaces[0].distance_in_km > 0">
                      ({{
                        job.workplaces[0].distance_in_km.toString().replace(".", ",")
                      }}km)
                    </template>

                    <template v-if="job.workplaces.length > 2">
                      + {{ job.workplaces.length - 1 }} weitere Orte
                    </template>
                    <template v-else-if="job.workplaces.length > 1">
                      und {{ job.workplaces[1].city }}
                    </template>
                  </template>
                </template>
              </span>
              <template v-if="job.initiativ !== true">
                <span v-if="job.type" class="d-inline-block me-3"
                  ><i class="fas fa-fw fa-clock"></i>
                  {{ job.type }}
                </span>
                <span v-if="job.contract" class="d-inline-block me-3"
                  ><i class="fas fa-fw fa-suitcase"></i>
                  {{ job.contract }}
                </span>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-12">
            <h2>Leider gibt es zu Ihrer Suche keine passenden Jobs.</h2>
          </div>
        </template>
      </div>
    </div>
    <div class="mobile-filter d-block d-lg-none shadow">
      <div class="container">
        <div class="col-12">
          <a
            aria-controls="collapseFilters"
            aria-expanded="false"
            class="btn btn-primary btn-filters-mobile w-100 text-white"
            data-bs-toggle="collapse"
            href="#collapseFilters"
            role="button"
          ></a>
        </div>
        <div id="collapseFilters" class="collapse">
          <div class="row mt-3">
            <div class="col-12 mb-2">
              <filter-select
                v-model="businessFilters"
                :labels="filters.business"
                placeholder="Bereich"
              ></filter-select>
              <filter-container
                v-model="businessFilters"
                :labels="filters.business"
              ></filter-container>
            </div>
            <div class="col-12 mb-2">
              <filter-select
                v-model="typesFilters"
                :labels="filters.types"
                placeholder="Anstellungsart"
              ></filter-select>
              <filter-container
                v-model="typesFilters"
                :labels="filters.types"
              ></filter-container>
            </div>
            <div class="col-12 mb-2">
              <filter-select
                v-model="contractsFilters"
                :labels="filters.contracts"
                placeholder="Vertragsart"
              ></filter-select>
              <filter-container
                v-model="contractsFilters"
                :labels="filters.contracts"
              ></filter-container>
            </div>
            <div class="col-12 text-center">
              <button class="btn btn-primary w-100 text-white" @click="resetFilters">
                Alle Filter löschen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <toaster v-model="errorMessage"></toaster>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import FilterSelect from "./FilterSelect";
import FilterContainer from "./FilterContainer";
import DelayedSearch from "./DelayedSearch";
import LocationSearch from "./LocationSearch";
import DistanceDropdown from "./DistanceDropdown";
import Toaster from "../Toaster";

// props
const props = defineProps({
  templateOptions: Object,
  apiEndpoints: Object,
  getParameters: Object,
});

const errorMessage = ref("");

// filter definitions and values
const filters = ref({});

// active filters
const businessFilters = ref([]);
const typesFilters = ref([]);
const contractsFilters = ref([]);
const search = ref(props.getParameters.search || "");
const radius = ref(parseInt(props.getParameters.search) || 0);
const location = ref({});

// set location from get-parameters
if (
  props.getParameters.hasOwnProperty("geo") &&
  props.getParameters.geo !== "" &&
  props.getParameters.hasOwnProperty("geo-id") &&
  props.getParameters.geoId !== "0"
) {
  location.value = {
    geo: props.getParameters.geo,
    geoId: props.getParameters["geo-id"],
  };
}

// search results
const jobs = ref([]);

// semaphore for spinner
const workers = ref(0);

// computed
const hasSearchResults = computed(() => {
  return Array.isArray(jobs.value);
});

// get business filter
axios
  .get("/ajax/" + props.apiEndpoints.business)
  .then((response) => {
    filters.value.business = {};
    for (let business of Object.keys(response.data)) {
      filters.value.business[business] = business;
    }
    // set filters from get parameters
    businessFilters.value = getFilterParameter("business");
    // watch filter
    watch(
      () => businessFilters,
      () => performSearch(),
      { deep: true }
    );
  })
  .catch((error) => {
    errorMessage.value = "Ein Fehler ist aufgetreten, versuche es später erneut.";
  });

// get types filter
axios
  .get("/ajax/" + props.apiEndpoints.types)
  .then((response) => {
    filters.value.types = {};
    for (let type of Object.keys(response.data)) {
      filters.value.types[type] = type;
    }
    // set filters from get parameters
    typesFilters.value = getFilterParameter("types");
    // watch filter
    watch(
      () => typesFilters,
      () => performSearch(),
      { deep: true }
    );
  })
  .catch((error) => {
    errorMessage.value = "Ein Fehler ist aufgetreten, versuche es später erneut.";
  });

// get contracts filter
axios
  .get("/ajax/" + props.apiEndpoints.contracts)
  .then((response) => {
    filters.value.contracts = {};
    for (let contract of Object.keys(response.data)) {
      filters.value.contracts[contract] = contract;
    }
    // set filters from get parameters
    contractsFilters.value = getFilterParameter("contracts");
    // watch filter
    watch(
      () => contractsFilters,
      () => performSearch(),
      { deep: true }
    );
  })
  .catch((error) => {
    errorMessage.value = "Ein Fehler ist aufgetreten, versuche es später erneut.";
  });

// method to reset filters
const resetFilters = () => {
  businessFilters.value = [];
  typesFilters.value = [];
  contractsFilters.value = [];
  search.value = "";
  location.value = {};
  radius.value = 0;
};

// get filter from get-parameters
const getFilterParameter = (parameterName) => {
  // if parameter present and not empty
  if (
    props.getParameters.hasOwnProperty(parameterName) &&
    props.getParameters[parameterName]
  ) {
    // get parameter as array
    let parameterArray = Array.isArray(props.getParameters[parameterName])
      ? props.getParameters[parameterName]
      : [props.getParameters[parameterName]];
    // return only valid filters that are present in filter-definition
    return parameterArray.filter((value) => {
      return filters.value[parameterName].hasOwnProperty(value);
    });
  }
  return [];
};

// watchers
watch(search, () => performSearch());
watch(radius, () => performSearch());
watch(location, () => performSearch());

// search method
const performSearch = () => {
  workers.value++;
  let searchQuery = "?search=" + search.value;

  if (location.value.hasOwnProperty("geoId") && location.value.geoId > 0) {
    searchQuery += "&geo-id=" + location.value.geoId;
    searchQuery += "&geo=" + location.value.geo;
    searchQuery += "&radius=" + radius.value;
  }

  searchQuery += serializeFilter("business", businessFilters.value);

  searchQuery += serializeFilter("types", typesFilters.value);

  searchQuery += serializeFilter("contracts", contractsFilters.value);

  axios
    .get("/ajax/" + props.apiEndpoints.jobs + searchQuery)
    .then((response) => {
      jobs.value = response.data;
    })
    .catch((error) => {
      errorMessage.value = "Ein Fehler ist aufgetreten, versuche es später erneut.";
    })
    .finally(() => {
      workers.value--;
    });
};

// method to serialize filter options
const serializeFilter = (parameter, values) => {
  let query = "";
  if (values.length > 0) {
    values.forEach((value) => {
      query += "&" + parameter + "[]=" + value;
    });
  }
  return query;
};

// lifecycle hooks
onMounted(() => {
  performSearch();
});
</script>
